<template>
    <tbody>
    <tr v-for="(opportunity, index) in opportunities" class="relative">
        <TableCustomBorder :fullBorder="index === 0"/>
        <td class="py-3 px-4 flex flex-col sm:block">
            {{ opportunity.companyName }}
            <span class="sm:hidden text-sm font-bold text-gray-400">{{ opportunity.createdDate }}</span>
        </td>
        <td class="py-3 px-4 hidden sm:table-cell">{{ opportunity.createdDate }}</td>
        <td class="py-3 px-4 hidden sm:table-cell">{{ opportunity.employeeName }}</td>
        <td class="py-3 px-4 text-right sm:text-left">
                    <span :class="['capitalize px-2 py-1 rounded-xl text-sm', getStatusClasses(opportunity.status)]">
                        {{ opportunity.status }}</span>
        </td>
    </tr>
    </tbody>
</template>

<script>
import TableCustomBorder from "@/Components/TableCustomBorder";

export default {
    props: ['opportunities'],
    components: {TableCustomBorder},
    methods: {
        getStatusClasses(status) {
            switch (status) {
                case 'open':
                    return 'bg-blue-100';
                case 'won':
                    return 'bg-green-100';
                case 'lost':
                    return 'bg-red-100';
                default:
                    return 'bg-blue-100';
            }
        }
    },
}
</script>
